import { IncentivePage } from "./IncentivePage";

type IncentiveProps = {
	assetId: number;
};

export const Incentive = ({ assetId }: IncentiveProps) => {
	return <IncentivePage assetId={assetId} />;
};
